/**
 * Hide retail free-shipping progress + GWP UI when a B2B membership fee
 * product is present in the cart (drawer + cart page, including AJAX redraws).
 */
(function () {
  'use strict';

  var DEFAULT_HANDLES = ['pro-membership-fee', 'abh-pro-subscription-fee'];
  var SELECTORS = [
    '[js-cart-shipping-progress]',
    '[js-gwp-container]',
    '.cart-drawer__progress-bar-wrapper',
    '.cart__progress-bar-wrapper',
    '.cart-gwp',
  ];
  var ATTR = 'data-abh-fee-ui-hidden';
  var syncTimer = null;
  var lastHasFee = false;

  function feeHandles() {
    var config = window.ABH_PRO_CART_FEE || {};
    var handles = Array.isArray(config.handles) ? config.handles.slice() : DEFAULT_HANDLES.slice();
    return handles
      .map(function (h) {
        return String(h || '')
          .trim()
          .toLowerCase();
      })
      .filter(Boolean);
  }

  function itemLooksLikeFee(item, handles) {
    if (!item) return false;
    var handle = String(item.handle || '')
      .trim()
      .toLowerCase();
    if (handle && handles.indexOf(handle) !== -1) return true;

    var title = String(item.product_title || item.title || '').toLowerCase();
    if (title.indexOf('subscription fee') !== -1 || title.indexOf('membership fee') !== -1) {
      return true;
    }

    var url = String(item.url || '').toLowerCase();
    for (var i = 0; i < handles.length; i++) {
      if (url.indexOf('/products/' + handles[i]) !== -1) return true;
    }
    return false;
  }

  function cartHasFee(cart) {
    var handles = feeHandles();
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (itemLooksLikeFee(items[i], handles)) return true;
    }
    return false;
  }

  function setHidden(el, hide) {
    if (!el) return;
    if (hide) {
      el.setAttribute('hidden', '');
      el.setAttribute(ATTR, 'true');
      el.style.setProperty('display', 'none', 'important');
    } else if (el.getAttribute(ATTR) === 'true') {
      el.removeAttribute('hidden');
      el.removeAttribute(ATTR);
      el.style.removeProperty('display');
    }
  }

  function applyVisibility(hasFee) {
    lastHasFee = !!hasFee;
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        setHidden(el, lastHasFee);
      });
    });
  }

  function cartRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function syncFromCart(cart) {
    applyVisibility(cartHasFee(cart));
  }

  function fetchAndSync() {
    return fetch(cartRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js ' + res.status);
        return res.json();
      })
      .then(syncFromCart)
      .catch(function () {
        /* non-blocking */
      });
  }

  function scheduleSync(delay) {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      fetchAndSync();
    }, typeof delay === 'number' ? delay : 50);
  }

  function isCartMutationUrl(url) {
    if (!url) return false;
    try {
      var path = String(url);
      if (path.indexOf('http') === 0) {
        path = new URL(path, window.location.origin).pathname;
      }
      return /\/cart(\/add|\/change|\/update|\/clear)?(\.js)?(\?|$)/.test(path);
    } catch (e) {
      return false;
    }
  }

  function installFetchHook() {
    if (window.fetch && !window.fetch.__abhFeeUiWrapped) {
      var originalFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var input = args[0];
        var url = typeof input === 'string' ? input : input && input.url;
        return originalFetch.apply(this, args).then(function (response) {
          if (isCartMutationUrl(url)) {
            // Section re-renders may land after the network response resolves.
            scheduleSync(100);
            scheduleSync(400);
          }
          return response;
        });
      };
      window.fetch.__abhFeeUiWrapped = true;
    }

    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__abhFeeUiWrapped) {
      var open = XMLHttpRequest.prototype.open;
      var send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__abhFeeUiUrl = url;
        return open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        this.addEventListener('loadend', function () {
          if (isCartMutationUrl(this.__abhFeeUiUrl)) {
            scheduleSync(100);
            scheduleSync(400);
          }
        });
        return send.apply(this, arguments);
      };
      XMLHttpRequest.prototype.__abhFeeUiWrapped = true;
    }
  }

  function installDomObserver() {
    var targets = [
      document.querySelector('#CartDrawer'),
      document.querySelector('[js-cart-drawer-contents]'),
      document.querySelector('[js-cart-page-contents]'),
    ].filter(Boolean);

    if (!targets.length || typeof MutationObserver === 'undefined') return;

    var raf = null;
    var observer = new MutationObserver(function () {
      if (!lastHasFee) return;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        applyVisibility(true);
      });
    });

    targets.forEach(function (node) {
      observer.observe(node, { childList: true, subtree: true });
    });
  }

  function init() {
    installFetchHook();
    fetchAndSync();
    installDomObserver();
    document.addEventListener('cart:updated', function () {
      scheduleSync(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
